export const Periods = Object.freeze({
  UPCOMING: 'upcoming',
  PAST: 'past',
  FIXED: 'fixed',
  THIS_WEEK: 'this_week',
  THIS_MONTH: 'this_month',
  THIS_YEAR: 'this_year',
  TODAY: 'today',
  ALL_TIME: 'all_time'
})

export const FilterTypes = Object.freeze({
  TEAMS: 'teamsSelect',
  USERS: 'usersSelect',
  STATUS: 'status',
  SCHEDULING_METHOD: 'schedulingMethod',
  ROLE: 'role',
  TRACKING_SELECT: 'trackingSelect',
  BUFFER_VIEW: 'bufferView',
  NOTETAKER_RECAP: 'notetakerRecap'
})

export const allValue = 'all'

// Participants
export const myMeetingsValue = 'my_meetings'

export const permissionValue = 'permission'

export const nonHostValue = 'non_host'


// Status
export const activeValue = 'active'

export const Statuses = {
  ALL: 'all',
  ACTIVE: 'active',
  CANCELED: 'canceled',
  NO_SHOW: 'no_show',
  RESCHEDULED: 'rescheduled',
}

export const FILTER_SCOPE_TYPES = {
  user: ['users', 'teams', 'team', 'all_users_and_teams', 'user_group'],
  team: ['user', 'teams', 'all_users_and_teams']
}

export {
  AllSchedulingMethods,
  buildSchedulingMethodProps,
  normalizePersistedSchedulingMethods,
  SchedulingMethods
} from 'services/search_api/constants'

export const MATCH_MEETING = 'name'
export const MATCH_ATTENDEE = 'attendees'
export const MATCH_TRANSCRIPT = 'transcript'

export const MeetingRoles = {
  HOST: 'HOST',
  COHOST: 'COHOST',
  ATTENDEE: 'ATTENDEE',
  PERMISSION: 'PERMISSION'
}

export const ANALYTICS_MAP = {
  period: 'date_range',
  dateRange: 'date_range',
  inviteeEmails: 'invitee_email',
  eventTypeIds: 'event_type',
  teamIds: 'team',
  userIds: 'user',
  statusIds: 'meeting_status',
  status: 'meeting_status',
  schedulingMethods: 'scheduling_method',
  schedulingMethod: 'scheduling_method',
  role: 'role',
  meetingIntelligenceStatus: 'notetaker_recap'
}

export const allowedScopeTypes = [
  'my_calendly',
  'page_single',
  'user_group',
  'user_single'
]
